import apiClient from './apiClient';
import { GET_MANAGER, UPDATE_MANAGER } from '../constants/UriConstants';
import { ManagerInterface } from '../types/ManagerInterface';

export const getManager = (): Promise<ManagerInterface> => apiClient.get(GET_MANAGER).then((response) => response.data);

export const editManager = async (manager: ManagerInterface): Promise<void> => {
  await apiClient.put(UPDATE_MANAGER, manager);
};
